// src/contexts/ExportDialogContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';
import ExportDialog from '../components-ui/export-dialog/ExportDialog';


export interface IExportDialogOptions {
  title?: string;
  endPoint: string;
  data?: any;
  isLandscape?: boolean;
  showPreview?: boolean;
}

interface IExportDialogContextValue {
  showExportDialog: (options: IExportDialogOptions) => void;
  hideExportDialog: () => void;
}

const ExportDialogContext = createContext<IExportDialogContextValue | undefined>(undefined);

export const useExportDialog = () => {
  const context = useContext(ExportDialogContext);
  if (!context) {
    throw new Error('useExportDialog must be used within ExportDialogProvider');
  }
  return context;
};

interface IExportDialogProviderProps {
  children: ReactNode;
}

export const ExportDialogProvider: React.FC<IExportDialogProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dialogOptions, setDialogOptions] = useState<IExportDialogOptions | null>(null);

  const showExportDialog = (options: IExportDialogOptions) => {
    setDialogOptions(options);
    setIsOpen(true);
  };

  const hideExportDialog = () => {
    setIsOpen(false);
    setDialogOptions(null);
  };

  return (
    <ExportDialogContext.Provider value={{ showExportDialog, hideExportDialog }}>
      {children}
      {isOpen && dialogOptions && (
        <ExportDialog
          isOpen={isOpen}
          onClose={hideExportDialog}
          options={dialogOptions}
        />
      )}
    </ExportDialogContext.Provider>
  );
};